<!-- ACT共通コンポーネント -->
<template>
  <!-- PC版レイアウト -->
  <!-- <div v-if="isEnvironmentPc()" :class="[layoutObj.containerClass, activeType, { 'cards-container':  isUseCardsContainer } ]"> -->
  <div v-if="isEnvironmentPc()" :class="[layoutObj.containerClass, activeType, 'cards-container']">

    <template v-for="rowIndex in layoutObj.actNums.length">
      <div :id="'group' + rowIndex" class="group-column" :key="rowIndex">
        <template v-for="classIndex in layoutObj.actNums[rowIndex -1].length">

          <!-- テキスト出題形式のレイアウト -->
          <template v-if="!horizontalRow">
            <div class="card-inner card-voice" :class="layoutObj.innerClasses[rowIndex -1][classIndex -1]" :key="classIndex">
              <template v-for="actIndex in layoutObj.actNums[rowIndex -1][classIndex -1]">
                <div :id="'Item' + getTargetAct(rowIndex, classIndex, actIndex)" class="item" :key="actIndex"
                  :class="{ challenge: !isAnswers[getTargetAct(rowIndex, classIndex, actIndex)] & actChoice & isChallenge(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)]),
                            type1: !isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)] & !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)]),
                            active: isActivesAct[getTargetAct(rowIndex, classIndex, actIndex)],
                            disabled: !actChoice & pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)].inDisabled,
                            context: isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])
                          }"
                            @click="clickItem(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], getTargetAct(rowIndex, classIndex, actIndex))"
                  :style="{ cursor: cursorTypes[getTargetAct(rowIndex, classIndex, actIndex)] }">
                  <button v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)] && showPinchInBtn" class="icon-pinch-in"
                          @click="clickPinchIn(
                            pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)],
                            actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)],
                            showAnswerText[getTargetAct(rowIndex, classIndex, actIndex)],
                            isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)],
                            isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)],
                            basicTextList[getTargetAct(rowIndex, classIndex, actIndex)],
                            getTargetAct(rowIndex, classIndex, actIndex))">
                  </button>

                  <!-- Tile系のテキスト -->
                  <template v-if="actTextListChild.length != 0">
                    <div v-if="showAnswerText[getTargetAct(rowIndex, classIndex, actIndex)]">
                      <div v-if="!isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])"
                      style="visibility: visible;" class="select" :class="getTextFontClassAct(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)], $parent.productLanguage)">
                        <span v-html="getPopupTextElem(actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].answerText)"></span>
                      </div>
                      <div v-else style="visibility: hidden;" class="select" :class="getTextFontClassAct(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)], $parent.productLanguage)">
                        <span v-html="getPopupTextElem(actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].answerText)"></span>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="!isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])"
                       style="visibility: visible;" class="select" :class="getTextFontClassAct(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)], $parent.productLanguage)">
                         <span v-html="getPopupTextElem(actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].questionText)"></span>
                      </div>
                      <div v-else style="visibility: hidden;" class="select" :class="getTextFontClassAct(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)], $parent.productLanguage)">
                         <span v-html="getPopupTextElem(actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].questionText)"></span>
                      </div>
                    </div>
                  </template>

                  <!-- Tile系以外のテキスト -->
                  <template v-else>
                    <p v-if="!isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" style="visibility: visible;" :class="getTextFontClassAct(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)], $parent.productLanguage)">
                      <span v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]" v-html="getPopupTextElem(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)])" />
                    </p>
                    <p v-else style="visibility: hidden;" :class="getTextFontClassAct(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)], $parent.productLanguage)">
                      <span v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]" v-html="getPopupTextElem(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)])" />
                    </p>
                  </template>
                  <div class="card">
                    <div :class="{ correct: isCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)], incorrect: isInCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)]}"></div>
                    <div class="image">
                      <img :src="pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)].image" />
                      <p v-if="hasImageText(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" :class="getImageTextFontClass($parent.productLanguage, getImageText($parent.productLanguage, pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], scriptType))">
                        {{ getImageText($parent.productLanguage, pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], scriptType) }}
                      </p>
                    </div>
                    <button v-show="isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)] && !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" class="icon-voice" @click="actAudioPlay(getTargetAct(rowIndex, classIndex, actIndex))"></button>
                  </div>
                </div>
              </template>
            </div>
          </template>

          <!-- 画像出題形式のレイアウト -->
          <template v-else>
            <div class="card-inner" :class="layoutObj.innerClasses[rowIndex -1][classIndex -1]" :key="classIndex">
              <template v-for="actIndex in layoutObj.actNums[rowIndex -1][classIndex -1]">
                <div :id="'Item' + getTargetAct(rowIndex, classIndex, actIndex)" class="item" :key="actIndex"
                  :class="{ complete: isCompletes[getTargetAct(rowIndex, classIndex, actIndex)],
                            active: isActivesAct[getTargetAct(rowIndex, classIndex, actIndex)] }"
                  :style="{ cursor: cursorTypes[getTargetAct(rowIndex, classIndex, actIndex)] }">
                  <button v-show="isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]" class="icon-voice" @click="actAudioPlay(getTargetAct(rowIndex, classIndex, actIndex))"></button>
                  <div class="item-inner" @click="clickItem(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], getTargetAct(rowIndex, classIndex, actIndex))"
                    :class="{ challenge: actChoice && !isCompletes[getTargetAct(rowIndex, classIndex, actIndex)] && isChallenge(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)]) }"
                    :style="{ cursor: cursorTypes[getTargetAct(rowIndex, classIndex, actIndex)] }">
                    <button v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)] && showPinchInBtn" class="icon-pinch-in"
                            @click="clickPinchIn(
                              pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)],
                              actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)],
                              showAnswerText[getTargetAct(rowIndex, classIndex, actIndex)],
                              isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)],
                              isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)],
                              basicTextList[getTargetAct(rowIndex, classIndex, actIndex)],
                              getTargetAct(rowIndex, classIndex, actIndex))">
                    </button>
                    <div class="word" :class="getTextFontClassAct(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)], $parent.productLanguage)"><span v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]" v-html="getPopupTextElem(basicTextList[getTargetAct(rowIndex, classIndex, actIndex)])" ></span></div>
                    <div class="card">
                      <div :class="{ correct: isCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)], incorrect: isInCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)]}"></div>
                      <div v-if="isCompletes[getTargetAct(rowIndex, classIndex, actIndex)]" class="aimage"><img :src="pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)].image" /></div>
                      <div v-else class="aimage"><img src="/static/images/blank.jpg"/></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </template>
      </div>
    </template>
  </div>
  <!-- スマホ版レイアウト -->
  <div v-else class="cards-container" :class="[layoutObj.containerClass, activeType, swiperContainer1ClassName]">
    <div :class="swiperWrapperClassName">
      <template v-for="rowIndex in layoutObj.actNums.length">
        <template v-for="classIndex in layoutObj.actNums[rowIndex -1].length">

          <!-- テキスト出題形式のレイアウト -->
          <template v-if="!horizontalRow">
            <div class="card-inner card-voice" :class="[layoutObj.innerClasses[rowIndex -1][classIndex -1], swiperSlideClassName]" :key="'row' + rowIndex + 'class' + classIndex">
              <div :class="swiperContainer2ClassName">
                <div :class="swiperWrapperClassName">
                  <template v-for="actIndex in layoutObj.actNums[rowIndex -1][classIndex -1]">
                    <div :id="'Item' + getTargetAct(rowIndex, classIndex, actIndex)" class="item" :key="actIndex"
                      :class="[{ challenge: !isAnswers[getTargetAct(rowIndex, classIndex, actIndex)] & actChoice & isChallenge(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)]),
                                type1: !isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)] & !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)]),
                                active: isActivesAct[getTargetAct(rowIndex, classIndex, actIndex)],
                                disabled: !actChoice & pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)].inDisabled,
                                context: isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])
                              }, swiperSlideClassName]"
                                @click="clickItem(pathstep.acts[getTargetAct(rowIndex,classIndex,actIndex)],getTargetAct(rowIndex,classIndex,actIndex))"
                                @touchstart="onTouchStart(
                                  pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)],
                                  actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)],
                                  showAnswerText[getTargetAct(rowIndex, classIndex, actIndex)],
                                  isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)],
                                  isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)],
                                  basicTextList[getTargetAct(rowIndex, classIndex, actIndex)],
                                  getTargetAct(rowIndex, classIndex, actIndex))"
                                @touchend="onTouchEnd()" @touchmove="onTouchEnd()">

                      <!-- Tile系のテキスト -->
                      <template v-if="actTextListChild.length != 0">
                        <div v-if="showAnswerText[getTargetAct(rowIndex, classIndex, actIndex)]">
                          <div v-if="!isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" style="visibility: visible;" class="select">
                             <span v-html="actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].answerText"></span>
                          </div>
                          <div v-else style="visibility: hidden;" class="select">
                             <span v-html="actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].answerText"></span>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="!isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" style="visibility: visible;" class="select">
                             <span v-html="actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].questionText"></span>
                          </div>
                          <div v-else style="visibility: hidden;" class="select">
                             <span v-html="actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)].questionText"></span>
                          </div>
                        </div>

                        <div class="card">
                          <div :class="{ correct: isCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)], incorrect: isInCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)]}"></div>
                          <div class="image">
                            <img :src="pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)].image" />
                            <p v-if="hasImageText(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" v-auto-adjust
                              :class="isImageTextAutoAdjust ? '' : getImageTextFontClass($parent.productLanguage, getImageText($parent.productLanguage, pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], scriptType))">
                              {{ getImageText($parent.productLanguage, pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], scriptType) }}
                            </p>
                          </div>
                          <button v-show="isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]  && !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" class="icon-voice" @click="actAudioPlay(getTargetAct(rowIndex, classIndex, actIndex))"></button>
                        </div>
                      </template>

                      <!-- Tile系以外のテキスト -->
                      <template v-else>
                        <div>
                          <p v-if="!isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" style="visibility: visible;">
                            <span v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]" v-html="basicTextList[getTargetAct(rowIndex, classIndex, actIndex)]" />
                          </p>
                          <p v-else style="visibility: hidden;">
                            <span v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]" v-html="basicTextList[getTargetAct(rowIndex, classIndex, actIndex)]" />
                          </p>

                          <div class="card">
                            <div :class="{ correct: isCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)], incorrect: isInCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)]}"></div>
                            <div class="image">
                              <img :src="pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)].image" />
                              <p v-if="hasImageText(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" v-auto-adjust
                                :class="isImageTextAutoAdjust ? '' : getImageTextFontClass($parent.productLanguage, getImageText($parent.productLanguage, pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], scriptType))">
                                <span>{{ getImageText($parent.productLanguage, pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], scriptType) }}</span>
                              </p>
                            </div>
                            <button v-show="isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]  && !isContext(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)])" class="icon-voice" @click="actAudioPlay(getTargetAct(rowIndex, classIndex, actIndex))"></button>
                          </div>
                        </div>
                      </template>

                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>

          <!-- 画像出題形式のレイアウト -->
          <template v-else>
            <div class="card-inner card-voice" :class="[layoutObj.innerClasses[rowIndex -1][classIndex -1], swiperSlideClassName]" :key="'row' + rowIndex + 'class' + classIndex">
              <div :class="swiperContainer2ClassName">
                <div :class="swiperWrapperClassName">
                  <template v-for="actIndex in layoutObj.actNums[rowIndex -1][classIndex -1]">
                    <div :id="'Item' + getTargetAct(rowIndex, classIndex, actIndex)" class="item" :key="actIndex"
                      :class="[{ complete: isCompletes[getTargetAct(rowIndex, classIndex, actIndex)],
                                active: isActivesAct[getTargetAct(rowIndex, classIndex, actIndex)] }, swiperSlideClassName]"
                                @touchstart="onTouchStart(
                                  pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)],
                                  actTextListChild[getTargetAct(rowIndex, classIndex, actIndex)],
                                  showAnswerText[getTargetAct(rowIndex, classIndex, actIndex)],
                                  isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)],
                                  isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)],
                                  basicTextList[getTargetAct(rowIndex, classIndex, actIndex)],
                                  getTargetAct(rowIndex, classIndex, actIndex))"
                                @touchend="onTouchEnd()" @touchmove="onTouchEnd()">
                      <div>
                        <button v-show="isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]" class="icon-voice" @click="actAudioPlay(getTargetAct(rowIndex, classIndex, actIndex))"></button>
                        <div class="item-inner" @click="clickItem(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)], getTargetAct(rowIndex, classIndex, actIndex))"
                          :class="{ challenge: actChoice && !isCompletes[getTargetAct(rowIndex, classIndex, actIndex)] && isChallenge(pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)]) }">
                          <p class="word"><span v-show="isShowTextsAct[getTargetAct(rowIndex, classIndex, actIndex)]" v-html="basicTextList[getTargetAct(rowIndex, classIndex, actIndex)]"></span></p>
                          <div class="card">
                            <div :class="{ correct: isCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)], incorrect: isInCorrectsAct[getTargetAct(rowIndex, classIndex, actIndex)]}"></div>
                            <div v-if="isCompletes[getTargetAct(rowIndex, classIndex, actIndex)]" class="aimage"><img :src="pathstep.acts[getTargetAct(rowIndex, classIndex, actIndex)].image" /></div>
                            <div v-else class="aimage"><img src="/static/images/blank.jpg"/></div>
                            <button v-show="isShowVoicesAct[getTargetAct(rowIndex, classIndex, actIndex)]" class="icon-voice icon-voice02" @click="actAudioPlay(getTargetAct(rowIndex, classIndex, actIndex))"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>

        </template>
      </template>
    </div>
    <div v-if="needsSwiper" :class="{ 'swiper-pagination': actChoice }"></div>
    <div v-if="isScrollIconVisible" class="icon-scroll" />
  </div>
</template>
<script>
// 共通処理
import Vue from "vue";
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

export default {
  name: "CommonAct",
  props: {
    pathstep: Object,
    activeType: String,
    // 画像選択タイプのRunmodeかを判定する
    actChoice: Boolean,
    // 横一列レイアウトかを判定する
    horizontalRow: Boolean,
    actTextList: Array,
    // 監視用ステータス
    changeActTextList: Boolean,
    // 正解のAct
    answerAct: Object,
    // Actのテキスト表示するかを判断するBoolean配列
    isShowTextsParent: Array,
    // 監視用ステータス
    changeIsShowTexts: Boolean,
    // Actの音声再生アイコンを表示するかを判断するBoolean配列
    isShowVoicesParent: Array,
    // 監視用ステータス
    changeIsShowVoices: Boolean,
    // activeクラスを適用するかを判断するBoolean配列
    isActivesParent: Array,
    // 監視用のステータス
    changeActives: Boolean,
    // 監視用のステータス
    changeEndAct: Boolean,
    // 正解かを判断するBoolean配列
    isCorrectsParent: Array,
    // 監視用ステータス
    changeIsCorrects: Boolean,
    // 不正解かを判断するBoolean配列
    isInCorrectsParent: Array,
    // 監視用ステータス
    changeIsInCorrects: Boolean,
    // completeクラスを適用するかを判断するBoolean配列
    isCompleteParent: Array,
    // 監視用ステータス
    changeIsComplete: Boolean,
    isShowAnswerParent: Array,
    changeIsShowAnswer: Boolean,
    scriptSystems: Object,
    needsSwiper: Boolean,
    isImageTextAutoAdjust: Boolean,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio,
    constants
  ],
  data() {
    return {
      // 正解画像表示を判定するBoolean配列
      isCorrectsAct: [],
      // 不正解画像表示を判定するBoolean配列
      isInCorrectsAct: [],
      // Actのテキスト表示するかを判断するBoolean配列
      isShowTextsAct: [],
      // isShowTextsActを退避するための配列
      tempIsShowTextsAct: [],
      // Actの音声再生アイコンを表示するかを判断するBoolean配列
      isShowVoicesAct: [],
      // isShowVoicesActを退避するための配列
      tempIsShowVoicesAct: [],
      // activeクラスを適用するかを判断するBoolean配列
      isActivesAct: [],
      // isActivesActを退避するための配列
      tempIsActivesAct: [],
      // 正解表示しているActを判断すBoolean配列
      isAnswers: [],
      // isAnswersを退避するための配列
      tempIsAnswers: [],
      // 正解時アニメーション対象を判断するためのBoolean配列
      isAniTarget: [],
      // ボタン連打制御用
      isSelects: [],
      isCompletes: [],
      tempisCompletes: [],
      cursorTypes: [],
      // 正解のテキストを表示するかを判断するフラグ(Tile用)
      showAnswerText: [],
      // showAnswerTextを退避するための配列
      tempShowAnswerText: [],
      actTextListChild: [],
      // ピンチインを表示するかを判断するフラグ
      isShowPinchIn: false,
      // ピンチイン対象のACTを設定する
      pinchInAct: {},
      pinchTileText: {},
      pinchInShowAnswerText: false,
      pinchInShowVoice: false,
      pinchInShowTextAct: false,
      pinchInDispText: "",
      // 表示テキストリスト
      basicTextList: [],
      // ピンチインボタン表示フラグ
      showPinchInBtn: false,
      // ピンチインに渡すACTのindex
      pinchInActIndex: 0,
      // タッチイベント長押しタイマー
      touchTimer: null,
      // アニメーション中かを判断するオブジェクト（アニメーション中はPromise関数が設定される）
      runningCorrectAnimation: null,
      // IEとEdgeで音声再生動作しない問題に対応するためのAudioオブジェクト
      tileAudio: null
    };
  },
  computed: {
    isUseCardsContainer: function() {
      var result = true;

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1Q:
        case constants.RUNMODE_B1Q:
        case constants.RUNMODE_C1Q:
          var layoutObj = this.getLayoutObject(this.pathstep.layoutID);
          if (layoutObj.actNums.length > 1) {
            result = false;
          }
          break;

        default:
          result = true;
          break;
      }

      return result;
    },
    /**
     * ピンチイン表示
     * @returns {default.computed.$store.getters.showPinchIn}
     */
    showPinchIn: function() {
      return this.$store.getters.showPinchIn;
    },
    /**
     * ピンチイン音声再生Index
     * @returns {default.computed.$store.getters.pinchInAudioPlayActIndex}
     */
    pinchInAudioPlayActIndex: function() {
      return this.$store.getters.pinchInAudioPlayActIndex;
    },
    swiperContainer1ClassName: function() {
      return this.needsSwiper ? "swiper-container swiper-container1" : "";
    },
    swiperContainer2ClassName: function() {
      return this.needsSwiper ? "swiper-container swiper-container2" : "";
    },
    swiperWrapperClassName: function() {
      return this.needsSwiper ? "swiper-wrapper" : "";
    },
    swiperSlideClassName: function() {
      return this.needsSwiper ? "swiper-slide" : "";
    }
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    /**
     * 初期化処理
     */
    init: function() {
      const self = this;

      this.isShowTextsAct = this.isShowTextsParent;
      this.isShowVoicesAct = this.isShowVoicesParent;
      if (this.isCompleteParent != null) {
        this.isCompletes = this.isCompleteParent;
      }
      if (this.isShowAnswerParent != null) {
        this.showAnswerText = this.isShowAnswerParent;
      }
      if (this.actTextList != null) {
        this.actTextListChild = this.actTextList;
      }

      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.$parent.productLanguage, this.displayMode);

      // 表示テキスト一覧取得
      this.basicTextList = this.getLanguageBasicTextList(this.pathstep.acts, this.$parent.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);

      this.setCursorTypes();

      // カスタムディレクティブ設定
      Vue.directive("auto-adjust", {
        // 子要素更新時に発火
        componentUpdated: function() {
          if (self.isImageTextAutoAdjust) {
            // 画像用テキスト表示自動調整
            self.$parent.changeImageTextDisplay(true);
          }
        }
      });
    },
    /**
     * pathstep内の対象のActのIndexを取得する
     */
    getTargetAct: function(rowIndex, classIndex, actIndex) {
      if (rowIndex == 1) {
        if (classIndex == 1) {
          return actIndex - 1;
        } else {
          var actCount = 0;
          for (var i = 0; i < classIndex - 1; i++) {
            actCount += this.layoutObj.actNums[rowIndex - 1][i];
          }
          return actCount + actIndex - 1;
        }
      } else {
        var actCount = 0;
        for (var i = 0; i < this.layoutObj.actNums[rowIndex - 2].length; i++) {
          actCount += this.layoutObj.actNums[rowIndex - 2][i];
        }
        if (classIndex == 1) {
          return actCount + actIndex - 1;
        } else {
          for (var i = 0; i < classIndex - 1; i++) {
            actCount += this.layoutObj.actNums[rowIndex - 1][i];
          }
          return actCount + actIndex - 1;
        }
      }

      return 0;
    },
    /**
     * ACTのカーソルタイプを設定する
     * default:矢印マーク、pointer:指マーク
     */
    setCursorTypes: function() {
      this.log("CommonAct start setCursorTypes");

      if (this.actChoice) {
        return;
      }

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.horizontalRow) {
          if (this.isCompletes[i]) {
            this.cursorTypes[i] = constants.CURSOR_POINTER;
          } else {
            this.cursorTypes[i] = constants.CURSOR_DEFAULT;
          }
        } else {
          if (this.isShowVoicesAct[i]) {
            this.cursorTypes[i] = constants.CURSOR_POINTER;
          } else {
            this.cursorTypes[i] = constants.CURSOR_DEFAULT;
          }
        }
      }
    },
    /**
     * Actクリック時の処理
     */
    clickItem: function(act, index) {
      this.log("click Item");

      // ピンチイン時は後続処理を実行しない
      if (this.isShowPinchIn) {
        return;
      }

      const self = this;

      if (this.isContext(act)) {
        return;
      }
      if (this.horizontalRow) {
        if (this.isCompletes[index]) {
          // 音声再生アイコン表示有かつ、音声再生アイコンが活性の場合は、音声再生する
          var iconVoice = $(".icon-voice").attr("class");
          if (iconVoice.indexOf("disabled") == -1) {
            this.actAudioPlay(index);
          }
          return;
        }
      } else {
        if (this.isShowVoicesAct[index]) {
          // 音声再生アイコン表示有かつ、音声再生アイコンが活性の場合は、音声再生する
          var iconVoice = $(".icon-voice").attr("class");
          if (iconVoice.indexOf("disabled") == -1) {
            this.actAudioPlay(index);
          }
          return;
        }
      }

      if (!this.isChallenge(this.pathstep.acts[index])) {
        return;
      }

      if (this.isSelects[index] || this.isCorrectsAct.length > 0) {
        return;
      }

      this.isSelects[index] = true;

      const answer = function() {
        if (self.actChoice && self.answerAct != null) {
          self.isCorrectsAct = [];
          self.isInCorrectsAct = [];

          // 音声再生を停止してから、正解／不正解判定を行う
          self.$emit("audioPause");

          // 学習済登録
          self.$emit("updateLearnedGroup");

          if (self.answerAct.texts[0].basicText == act.texts[0].basicText) {
            // 正解の場合
            self.correctAct(index);
          } else {
            // 不正解の場合
            self.inCorrectAct(index);
          }
        }
      };
      if (this.needsSwiper) {
        this.sliderToActiveAct(index).then(answer);
      } else {
        answer();
      }
    },
    /**
     * 正解時の処理
     */
    correctAct: function(index) {
      this.log("CommonAct start correctAct");

      const self = this;

      this.$emit("changeActSelect");

      this.isCorrectsAct[index] = true;
      this.audioCorrect();
      this.setAniTarget(index);

      if (this.horizontalRow) {
        this.runningCorrectAnimation = this.correctAnimationImage(index).then(function() {
          self.finishedCorrectAnimation(index);
        });
      } else {
        this.runningCorrectAnimation = this.correctAnimationText(index).then(function() {
          self.finishedCorrectAnimation(index);
        });
      }
    },
    /**
     * 不正解時の処理
     */
    inCorrectAct: function(index) {
      this.log("CommonAct start inCorrectAct");

      const self = this;

      this.isInCorrectsAct[index] = true;
      this.audioInCorrect();

      this.setInterval(constants.INCORRECT_INTERVAL).then(function() {
        self.isInCorrectsAct = [];
        self.$emit("actInCorrect");
        self.isSelects[index] = false;
      });
    },
    /**
     * 正解時アニメーション後の処理
     */
    finishedCorrectAnimation(index) {
      this.log("CommonAct start finishedCorrectAnimation");

      this.runningCorrectAnimation = null;
      var eleS = null;
      if (this.horizontalRow) {
        eleS = $(".toparea-image img");
      } else {
        eleS = $(".toparea-play .input");
      }

      this.isCorrectsAct = [];
      this.deleteAniTarget();
      eleS.removeClass("hide");

      if (this.pathstep.challengeFillPolicy == "i") {
        this.isShowTextsAct[index] = true;
        this.isShowVoicesAct[index] = true;
        this.isAnswers[index] = true;
      }

      this.$emit("actCorrect", this.isShowTextsAct, this.isShowVoicesAct, index);
      this.isSelects[index] = false;
    },
    /**
     * 正解時アニメーションの移動先に#aniTargetを付与する
     */
    setAniTarget: function(index) {
      this.log("CommonAct start setAniTarget");

      var aniTarget = "";

      if (this.horizontalRow) {
        aniTarget = "#Item" + index + " .aimage";
      } else {
        aniTarget = "#Item" + index + " p";
      }
      $(aniTarget).attr("id", "aniTarget");
    },
    /**
     * #aniTargetを削除する
     */
    deleteAniTarget: function() {
      this.log("CommonAct start deleteAniTarget");

      var aniTarget = "";

      if (this.horizontalRow) {
        aniTarget = " .aimage";
      } else {
        aniTarget = " p";
      }
      $(aniTarget).removeAttr("id");
    },
    /**
     * 正解時アニメーション（テキスト）
     */
    correctAnimationText: function(index) {
      this.log("CommonAct start correctAnimationText");

      const self = this;

      let eleS = $(".toparea-play .item");
      let eleD = $("#aniTarget");
      let iconVoice = $(".toparea-play .icon-voice");
      let pinchIn = $(".toparea-play .icon-pinch-in");

      // 音声アイコンを非表示
      iconVoice.addClass("hide");
      pinchIn.addClass("hide");

      // 移動元の情報を取得
      let offsetTopS = eleS.offset().top;
      let offsetLeftS = eleS.offset().left;

      // 移動先の情報を取得
      let offsetTop = eleD.offset().top - $(".header").outerHeight();
      let offsetLeft = eleD.offset().left;
      let eleWidth = getComputedStyle(eleD.get(0), "").getPropertyValue("width");
      let eleHeight = eleD.outerHeight();
      let elePadding = eleD.css("padding");

      return new Promise(function(resolve, reject) {
        let eleSInput = eleS.find(".input");

        let zindex = 0;
        if (!self.isShowTextsAct[index]) {
          zindex = 3;
        }

        if (self.isEnvironmentPc()) {
          let eleSfont = self.getTargetFontClass(eleSInput);
          let eleDfont = self.getTargetFontClass(eleD);

          // 移動元のstyleを変更
          eleS.css({
            "z-index": "2",
            margin: "0",
            left: offsetLeftS,
            position: "absolute"
          });
          eleS.find(".input").css({
            width: "100%",
            height: "100%",
            "margin-right": "0"
          });

          // 文字切れしないようにするため、出題部分のfontクラスをActのフォントクラスに変更
          eleSInput.removeClass(eleSfont).addClass(eleDfont);

          // 移動animate実行
          eleS.stop().animate({
            top: offsetTop,
            left: offsetLeft,
            width: eleWidth + 2,
            height: eleHeight,
            "z-index": zindex
          }, 500, function() {
            setTimeout(function() {
              eleS.addClass("hide");
              iconVoice.removeClass("hide");
              eleS.css({
                top: 0,
                left: 0,
                position: "relative",
                width: "300px",
                height: "70px"
              });
              eleS.find(".input").css({
                width: "250px",
                "margin-right": "5px"
              });
              pinchIn.removeClass("hide");
              // fontクラスを元に戻す
              eleSInput.removeClass(eleDfont).addClass(eleSfont);
              resolve();
            }, 1000);
          });
        } else {
          // 要素の複製
          let cloneEleS = $(".toparea-play .item").clone();
          cloneEleS.attr("id", "cloneTarget");
          cloneEleS.prependTo(".page-content .toparea-play");
          eleS.css("opacity", "0");
          cloneEleS.css({
            top: offsetTopS,
            left: offsetLeftS,
            position: "absolute",
            margin: "0",
            "z-index": "99"
          });

          cloneEleS.find(".input").css({
            width: "100%",
            height: "100%",
            margin: "0",
            padding: elePadding
          });

          cloneEleS.stop().animate({
            top: offsetTop,
            left: offsetLeft,
            width: eleWidth,
            height: eleHeight,
            zIndex: zindex
          }, 500, function() {
            // テキストが収まるように自動調整
            cloneEleS.textfill({
              minFontPixels: constants.AUTO_ADJUST_FONT_SIZE[self.textSize].min,
              maxFontPixels: self.$parent.cardAreaFontSize[self.displayMode],
              allowOverflow: true
            });
            setTimeout(function() {
              $("#cloneTarget").remove();
              iconVoice.removeClass("hide");
              pinchIn.removeClass("hide");
              eleS.css("opacity", "1");
              resolve();
            }, 1000);
          });
        }
      });
    },
    /**
     * 正解時アニメーション(画像）
     */
    correctAnimationImage: function() {
      this.log("CommonAct start correctAnimationImage");

      const self = this;

      var eleS = $(".toparea-image img");
      var eleD = $("#aniTarget");

      // 移動元の情報を取得
      var offsetTopS = eleS.offset().top;
      var offsetLeftS = eleS.offset().left;
      var eleWidthS = eleS.outerWidth();
      var eleHeightS = eleS.outerHeight();

      // 移動先の情報を取得
      var offsetTop = eleD.offset().top;
      var offsetLeft = eleD.offset().left;
      var eleWidth = eleD.outerWidth();
      var eleHeight = eleD.outerHeight();

      return new Promise(function(resolve, reject) {
        // 移動元のstyleを変更
        eleS.css({
          top: offsetTopS,
          left: offsetLeftS,
          width: eleWidthS,
          height: eleHeightS
        });
        eleS.addClass("moveinput");

        var animateTop = offsetTop - $(".header").outerHeight();

        if (!self.isEnvironmentPc()) {
          var correct = $("#eleCorrect");
          correct.css({
            top: offsetTop,
            left: offsetLeft,
            width: eleWidth,
            height: eleHeight
          }).show();
        }

        // 移動animate実行
        eleS.stop().animate({
          top: animateTop,
          left: offsetLeft,
          width: eleWidth,
          height: eleHeight,
          "z-index": 2
        }, 500, function() {
          setTimeout(function() {
            eleS.addClass("hide");
            eleS.removeClass("moveinput");
            eleS.css({
              top: "",
              left: "",
              width: "",
              height: ""
            });
            if (!self.isEnvironmentPc()) {
              correct.hide();
            }
            resolve();
          }, 1000);
        });
      });
    },
    /**
     * ACTの音声再生ボタン押下時の処理
     */
    actAudioPlay: function(index) {
      this.log("CommonAct start actAudioPlay");

      const self = this;

      if (this.actTextListChild.length != 0) {
        var sounds = this.pathstep.acts[index].sounds;
        if (this.showAnswerText[index]) {
          this.audioPlay(sounds[sounds.length - 1]);
        } else {
          if (this.pathstep.mode != constants.RUNMODE_LTILE) {
            // IEとEdgeで動作しない問題に対応するため
            // 独自にAudioオブジェクトを生成して音声再生する
            this.tileAudio = new Audio();
            var promise = new Promise(function(res, rej) {
              self.disabledIconVoice();
              function loop(i) {
                return new Promise(function(resolve, reject) {
                  self.tileAudio.src = sounds[i];
                  self.tileAudio.load();
                  self.tileAudio.play();
                  var endedEvent = function(event) {
                    $(self.tileAudio).off("ended error", endedEvent);
                    var errorCode = "";
                    try {
                      errorCode = event.currentTarget.error.code;
                    } catch (e) {
                      errorCode = "none";
                    }
                    self.log("CommonAct end tileAudioPlay errorCode: " + errorCode);
                    resolve(i + 1);
                  };
                  $(self.tileAudio).on("ended error", endedEvent);
                }).then(function(count) {
                  if (count > sounds.length - 2) {
                    res();
                  } else {
                    loop(count);
                  }
                });
              }
              loop(0);
            });

            promise.then(function() {
              self.enabledIconVoice();
            });
          } else if (this.isIconVoiceEnabled()) {
            // LetterTileの場合にIEとEdgeで動作しない問題に対応するため
            // 独自にAudioオブジェクトを生成して音声再生する
            var lTileAudio = new Audio();

            this.disabledIconVoice();
            this.isAudioPlaying = true;
            lTileAudio.src = sounds[sounds.length - 1];
            lTileAudio.load();
            lTileAudio.play();
            var endedEventParent = function(event) {
              $(lTileAudio).off("ended error", endedEventParent);
              var errorCode = "";
              try {
                errorCode = event.currentTarget.error.code;
              } catch (e) {
                errorCode = "none";
              }
              self.log("CommonAct end lTileAudioPlayParent errorCode: " + errorCode);
              self.enabledIconVoice();
              lTileAudio.src = constants.AUDIO_MASK;
              lTileAudio.load();
              lTileAudio.play();
              var endedEventChild = function(event) {
                $(lTileAudio).off("ended error", endedEventChild);
                var errorCode = "";
                try {
                  errorCode = event.currentTarget.error.code;
                } catch (e) {
                  errorCode = "none";
                }
                self.log("CommonAct end lTileAudioPlayChild errorCode: " + errorCode);
                self.isAudioPlaying = false;
              };
              $(lTileAudio).on("ended error", endedEventChild);
            };
            $(lTileAudio).on("ended error", endedEventParent);
          }
        }
      } else if (this.isPseriesRumode()) {
        this.$emit("clickSound", index);
      } else {
        this.audioPlay(this.pathstep.acts[index].sounds[0]);
      }
    },
    /**
     * 全解答表示時の処理
     * 全てのACTのテキスト／音声アイコンを表示する
     */
    showAllAnswer: function() {
      this.log("CommonAct start showAllAnswer");

      this.tempIsShowTextsAct = this.isShowTextsAct;
      this.tempIsShowVoicesAct = this.isShowVoicesAct;
      this.tempIsAnswers = this.isAnswers;
      this.tempisCompletes = this.isCompletes;
      this.tempIsActivesAct = this.isActivesAct;
      this.tempShowAnswerText = this.showAnswerText;
      this.enabledIconVoice();

      var Texts = [];
      var Voices = [];
      var Answers = [];
      var complate = [];
      var actives = [];
      var answerText = [];
      for (var i = 0; i < this.pathstep.acts.length; i++) {
        Texts[i] = true;
        Voices[i] = true;
        Answers[i] = true;
        complate[i] = true;
        actives[i] = false;
        answerText[i] = true;
      }

      this.isShowTextsAct = Texts;
      this.isShowVoicesAct = Voices;
      this.isAnswers = Answers;
      this.isCompletes = complate;
      this.isActivesAct = actives;
      this.showAnswerText = answerText;
      this.setCursorTypes();
    },
    /**
     * 全解答解除時の処理
     * 全解答表示前の状態に戻す
     */
    hideAllAnswer: function() {
      this.log("CommonAct start hideAllAnswer");

      this.isShowTextsAct = this.tempIsShowTextsAct;
      this.isShowVoicesAct = this.tempIsShowVoicesAct;
      this.isAnswers = this.tempIsAnswers;
      this.isCompletes = this.tempisCompletes;
      this.isActivesAct = this.tempIsActivesAct;
      this.showAnswerText = this.tempShowAnswerText;
      this.setCursorTypes();
    },
    /**
     * ピンチインボタン押下時の処理
     */
    clickPinchIn: function(act, tileText, isShowAnswerText, isShowVoice, isShowTextAct, dispText, actIndex) {
      this.log("CommonAct start clickPinchIn");

      // アニメーション中は拡大表示しない
      if (this.runningCorrectAnimation != null) {
        return;
      }
      if (this.$parent.runningCorrectAnimation != null && this.$parent.runningCorrectAnimation != undefined) {
        return;
      }

      // 正解時の処理を行っている場合は何もしない
      if (this.$parent.isCorrectsState) {
        return;
      }

      // Tile系以外の場合、再度、isShowVoiceを確認
      if (this.actTextListChild.length == 0) {
        if (isShowVoice && !this.isContext(act)) {
          isShowVoice = true;
        } else {
          isShowVoice = false;
        }
      }

      this.isShowPinchIn = true;
      this.$emit("actPinchIn");

      var imageText, imageTextFontClass;
      if (this.hasImageText(act)) {
        var language = this.$parent.productLanguage;
        imageText = this.getImageText(language, act, this.scriptType);
        imageTextFontClass = this.getPinchInImageTextFontClass(language, imageText);
      }

      var pinchInActParams = {
        isShowPinchIn: true,
        pinchInAct: act,
        pinchTileText: tileText,
        pinchInShowAnswerText: isShowAnswerText,
        pinchInShowVoice: isShowVoice,
        pinchInShowTextAct: isShowTextAct,
        pinchInDispText: dispText,
        pinchInActIndex: actIndex,
        pinchImageText: imageText,
        pinchImageTextFontClass: imageTextFontClass,
        isCompletes: this.isCompletes,
        horizontalRow: this.horizontalRow
      };

      this.$store.dispatch("showPinchIn", pinchInActParams);
      this.log("CommonAct clickPinchIn: set lessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
    },
    /**
     * ピンチアウト押下通知を受け取る
     */
    recievePinchOut: function() {
      this.log("CommonAct start recievePinchOut");

      this.isShowPinchIn = false;

      // 再生中の音声停止
      this.audioPause();

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("CommonAct recievePinchOut: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    /**
     * 長押しイベント開始
     * @param Object act タップしたACT
     * @param Object tileText  Tile用テキスト
     * @param Boolean isShowAnswerText 回答表示フラグ
     * @param Boolean isShowVoice 音声再生表示フラグ
     * @param String dispText 表示テキスト
     * @param Int actIndex タップしたACTのindex
     */
    onTouchStart: function(act, tileText, isShowAnswerText, isShowVoice, isShowTextAct, dispText, actIndex) {
      var self = this;
      this.touchTimer = setTimeout(function() {
        self.clickPinchIn(act, tileText, isShowAnswerText, isShowVoice, isShowTextAct, dispText, actIndex);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    }
  },
  mounted: function() {
    // スマホの場合は、sliderを初期化
    if (!this.isEnvironmentPc() && this.needsSwiper) {
      this.sliderInit();
    }
  },
  watch: {
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newStatus) {
      this.log("CommonAct watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus) {
        this.showAllAnswer();
      } else {
        this.hideAllAnswer();
      }
    },
    changeIsShowTexts: function(newStatus) {
      if (newStatus) {
        this.isShowTextsAct = this.isShowTextsParent;
      }
    },
    changeIsShowVoices: function(newStatus) {
      if (newStatus) {
        this.isShowVoicesAct = this.isShowVoicesParent;
        this.setCursorTypes();
      }
    },
    changeActives: function(newStatus) {
      if (newStatus) {
        this.isActivesAct = [];
        this.isActivesAct = this.isActivesParent;
      }
    },
    changeEndAct: function(newStatus) {
      if (newStatus) {
        this.showAllAnswer();
        if (this.$store.getters.autoScreenTransition !== "true") {
          if (this.$parent.$parent.lessonJson.paths[this.$parent.$parent.pathIndex].title === constants.PATH_TITLE_REVIEW) {
            this.$parent.$parent.goDisabled = true;
          }
        }
      }
    },
    changeIsCorrects: function(newStatus) {
      if (newStatus) {
        this.isCorrectsAct = [];
        this.isInCorrectsAct = [];
        this.isInCorrectsAct = this.isInCorrectsParent;
        this.isCorrectsAct = this.isCorrectsParent;
      } else {
        this.isCorrectsAct = [];
      }
    },
    changeIsInCorrects: function(newStatus) {
      if (newStatus) {
        this.isCorrectsAct = this.isCorrectsParent;
        this.isInCorrectsAct = this.isInCorrectsParent;
      } else {
        this.isInCorrectsAct = [];
      }
    },
    changeIsComplete: function(newStatus) {
      if (newStatus) {
        this.isCompletes = this.isCompleteParent;
      }
    },
    changeIsShowAnswer: function(newStatus) {
      if (newStatus) {
        this.showAnswerText = this.isShowAnswerParent;
      }
    },
    changeActTextList: function(newStatus) {
      if (newStatus) {
        this.actTextListChild = [];
        this.actTextListChild = this.actTextList;
      }
    },
    actTextList: function(newStatus) {
      this.actTextListChild = newStatus;
    },
    /**
     * 中国語表示切り替え
     *
     * @param {String} newstatus
     */
    scriptType: function(newstatus) {
      // 表示テキスト一覧取得
      this.basicTextList = this.getLanguageBasicTextList(this.pathstep.acts, this.$parent.productLanguage, newstatus, this.displayMode, this.scriptSystems.default);
      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.$parent.productLanguage, this.displayMode);
    },
    /**
     * 表示切り替え
     *
     * @param {String} newstatus
     */
    displayMode: function(newstatus) {
      // 表示テキスト一覧取得
      this.basicTextList = this.getLanguageBasicTextList(this.pathstep.acts, this.$parent.productLanguage, this.scriptType, newstatus, this.scriptSystems.default);
      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.$parent.productLanguage, this.displayMode);
    },
    /**
     * ACTシャッフル時
     * @param array newActs
     */
    "pathstep.acts": function(newActs) {
      // 表示テキスト一覧取得
      this.basicTextList = this.getLanguageBasicTextList(this.pathstep.acts, this.$parent.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
    },
    /**
     * ピンチイン表示
     */
    showPinchIn: function(newShowPinchIn) {
      if (!newShowPinchIn) {
        // 閉じる
        this.recievePinchOut();
      }
    },
    /**
     * ピンチイン音声再生
     */
    pinchInAudioPlayActIndex: function(newPinchInAudioPlayActIndex) {
      if (newPinchInAudioPlayActIndex !== null) {
        // オーディオ再生
        this.$store.dispatch("setPinchInAudioPlayActIndex", null);
        this.actAudioPlay(newPinchInAudioPlayActIndex);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// CommonAct.vue?78946ab4